<template>
	<div class="page_content explore_entity_inside program v_22_1" aria-label="Program Guide Introduction">
  	<template v-if="!isLoading">
      <div class="row page-heading">
    		<div class="col-xl-8 col-lg-8 col-md-8 col-sm-6 col-6 input module_heading">
      		<div class="module_icon icon-list" id="programIntroTour"></div>
      		<template v-if="programGuide && programGuide.title">
            <program-guide-title :program-guide="programGuide"></program-guide-title>
          </template>
    		</div>

    		<template v-if="isWidget">
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 btn_container" :id="'creditProgressPopup_' + programGuide.uuid">
            <b-btn style="width: 225px; padding: 0;" @click="calculateCreditProgressClicked(programGuide)">
              <b-progress :max="progress.total" height="30px" style="cursor: pointer;" show-value>
                <b-progress-bar :value="Number(selected)" style="background-color: #532a6e;"></b-progress-bar>
                <b-progress-bar :value="progress.completed" style="background-color: #508002;"></b-progress-bar>
                <b-progress-bar :value="progress.notPlanned - selected" style="background-color: #cf7908;"></b-progress-bar>
              </b-progress>
            </b-btn>
          </div>
        </template>
        <template v-else>
          <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 btn_container" v-if="showBackToResultButton">
            <b-btn @click.stop.prevent="returnToClicked" :aria-label="deCamelCase()" class="float-right">
    					<span class="btn_ic ic-back"></span>
    					<span class="btn_txt"> {{ deCamelCase() }} </span>
    				</b-btn>
            <span v-if="showAddCompletedCoursesOnResult">
              <b-button @click="addCompletedCourses" aria-label="add completed courses">Add Completed Courses</b-button>
            </span>
            <span class="lnk_req_credit"
              v-if="showCalculateRequiredCredit && isStudentLogin && planningStream && !isProgressCallFailed" :id="'creditProgressPopup_' + programGuide.uuid" @click="calculateCreditProgressClicked(programGuide)">
              <template v-if="isShowCourseProgressEnabled">
                <template v-if="showTransferredCoursesCreditProgress">
                  <div style="border: 1px solid #157099; margin: -3px -23px; font-size: 18px;">
                    <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transferredCourses}} out of {{progress.totalCourses}} courses</span>
                  </div>
                </template>
                <template v-else>
                  <b-btn style="width: 225px; padding: 0;">
                    <b-progress :max="progress.totalCourses" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                      <b-progress-bar :value="progress.transferredCourses" :precision="setPrecision(progress.transferredCourses)" style="background-color: #57b6e6;"></b-progress-bar>
                      <b-progress-bar :value="progress.completedCourses" :precision="setPrecision(progress.completedCourses)" style="background-color: #508002;"></b-progress-bar>
                      <b-progress-bar :value="progress.inProgressCourses" :precision="setPrecision(progress.inProgressCourses)" style="background-color: #9ec758;"></b-progress-bar>
                      <b-progress-bar :value="progress.notStartedCourses" :precision="setPrecision(progress.notStartedCourses)" style="background-color: #f5b318;"></b-progress-bar>
                      <b-progress-bar :value="progress.notPlannedCourses" :precision="setPrecision(progress.notPlannedCourses)" style="background-color: #cf7908;"></b-progress-bar>
                    </b-progress>
                  </b-btn>
                </template>
              </template>
              <template v-else>
                <template v-if="showTransferredCoursesCreditProgress">
                  <div style="border: 1px solid #157099; margin: -3px -23px; font-size: 18px;">
                    <span style="font-size: 15px; padding: 0 10px 0 10px; color: #8cbc3f;">saved {{progress.transfered}} out of {{progress.total}} credits</span>
                  </div>
                </template>
                <template v-else>
                  <b-btn style="width: 225px; padding: 0;">
                    <b-progress :max="progress.total" height="27px" style="cursor: pointer; margin-top: -4px;" show-value>
                      <b-progress-bar :value="progress.transfered" :precision="setPrecision(progress.transfered)" style="background-color: #57b6e6;"></b-progress-bar>
                      <b-progress-bar :value="progress.completed" :precision="setPrecision(progress.completed)" style="background-color: #508002;"></b-progress-bar>
                      <b-progress-bar :value="progress.inProgress" :precision="setPrecision(progress.inProgress)" style="background-color: #9ec758;"></b-progress-bar>
                      <b-progress-bar :value="progress.notStarted" :precision="setPrecision(progress.notStarted)" style="background-color: #f5b318;"></b-progress-bar>
                      <b-progress-bar :value="progress.notPlanned" :precision="setPrecision(progress.notPlanned)" style="background-color: #cf7908;"></b-progress-bar>
                    </b-progress>
                  </b-btn>
                </template>
              </template>
            </span>
      		</div>
        </template>
    	</div>

      <div class="page_content_container">
  			<div v-if="programGuide && programGuide.title">
    			<program-guide-menu
      			:cipCode="programGuide.cipCode"
      			:programGuideCode="programGuide.code"
      			:type="programGuide.type"
      			:returnTo="returnTo"
      			:active="'introduction'"
            :isWidget="isWidget"
            :selected="selected">
    			</program-guide-menu>
       	</div>
  			<div class="row pg_content">

					<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 content_rgt_panel content_tp_panel">
            <div v-if="programGuide && programGuide.title">
    					<program-guide-summary :showThirdBox="true" :showProgramAlumni="true"></program-guide-summary>
  					</div>
  					<div v-if="programGuide && programGuide.title">
  						<program-guide-recommendations
    						:cipCode="programGuide.cipCode"
    						:programGuideCode="programGuide.code"
    						:type="programGuide.type"
    						:returnTo="returnTo"
                :showBookmarks="true">
  						</program-guide-recommendations>
  					</div>
          </div> <!-- .content_rgt_panel -->

  				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 content_mid_panel">
  					<div class="row pg_sec">

							<!--
        			<div class="col-12 hd ace_sec_hd" :aria-label="programGuide.title + ' Program Introduction'">
	          		<h2>Description</h2>
	          		<span class="hd_bdr"></span>
	          	</div>
							-->
              <div class="col-12 sec_content">
                <div class="row" id="affInstitutionName">
                  <div class="col-12 tbl_sec">
                    <template v-if="showInstitutionName">
                      <div class="row content-row ace_sec_txt list_info_row inst_name" aria-label="program institution">
                         <div class="col-2 info_title">
                           Institution
                         </div>
                         <div class="col-10 info_val ace_sec_txt">
                          {{this.programGuide.institutionName}}
                          </div>
                       </div>
                    </template>
                  </div>
                </div>
              </div>

  	         	<div class="col-12 sec_content">
  							<div class="row" id="programDescription">
          				<div class="col-12 tbl_sec">
	           				<template v-if="programGuide && programGuide.description">
	           					<div class="content-row description_v4 ace_sec_txt" :aria-label="programGuide.description" v-html="programGuide.description"></div>
	           				</template>
	           				<template v-else>
	           					<div class="msg_no_data empty_pattern ace_sec_txt" aria-label="No description available for this program guide">
	           						No description available for this program guide
	           					</div>
	           				</template>
	        			  </div>
  		          </div>
  			  	  </div>

  		      </div>
          </div> <!-- .content_mid_panel -->


    		</div> <!-- .pg_content -->
        <template v-if="showCreditProgressPopup">
          <explore-program-credit-progress
              :title="selectedProgramGuide.title"
              :stream-id="planningStream.uuid"
              :program-id="selectedProgramGuide.uuid"
              :credit-progress-target-id="creditProgressTargetId"
              :is-widget="isWidget"
              :selected="Number(selected)">
          </explore-program-credit-progress>
        </template>
      </div> <!-- .page_content_container -->
    </template>
	</div>
</template>


<script>
import { mapState, mapActions } from 'vuex'
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import ProgramGuideMenu from './ProgramGuideMenu'
import ProgramGuideTitle from './ProgramGuideTitle'
import ProgramGuideRecommendations from './ProgramGuideRecommendations'
import ProgramGuideSummary from './ProgramGuideSummary'
import ExploreProgramCreditProgress from '../../explore/components/ExploreProgramCreditProgress'
import { StorageFactory } from '../../../storageFactory'

export const localStore = StorageFactory(() => localStorage)

export default {
  name: 'program-guide-introduction',
  props: ['cipCode', 'programGuideCode', 'type', 'returnTo', 'showBackToResultButton', 'isWidget', 'selected', 'loadDataFromServer', 'pgInstitutionId'],
  components: {
    ProgramGuideMenu,
    ProgramGuideTitle,
    ProgramGuideRecommendations,
    ProgramGuideSummary,
    ExploreProgramCreditProgress
  },
  data: () => {
    return {
      isLoading: true,
      programGuide: {},
      affiliatedIns : '',
      DEFAULT_TYPE: 'MAJOR',
      DEFAULT_RETURN_TO: 'exploreProgramGuideResults',
      EXPLORE_RESULTS: 'exploreProgramGuideResults',
      selectedProgramGuide: null,
      creditProgressTargetId: '',
      showCreditProgressPopup: false,
      progress: {},
      isProgressCallFailed: false
    }
  },

  created () {
    // this.showLoader()
  },

  async mounted () {
    await this.loadDataForProgramGuideIntroduction()
  },

  methods: {
    ...mapActions([
      'loadProgramGuide',
      'loadProgramGuideCareers',
      'saveProgramGuideState',
      'loadLogDashboardActivity',
      'loadProgramCreditProgress',
      'loadInstitutionOnlyDetail'
    ]),
    showLoader () {
      this.isLoading = true
      this.$parent.$refs.loadingModal.show()
    },
    hideLoader () {
      this.$parent.$refs.loadingModal.hide()
      this.isLoading = false
    },
    setPrecision (n) {
      if (Number(n) === n && n % 1 !== 0) {
        return 1
      }
      return 0
    },
    addCompletedCourses () {
      return this.$router.push({name: 'selfReportedCourseList'})
    },
    async loadDataForProgramGuideIntroduction () {
      this.showLoader()
      let cipCode = this.cipCode
      let programGuideCode = this.programGuideCode
      let programInstitutionId = this.pgInstitutionId
      let returnTo = this.returnTo && this.returnTo.length ? this.returnTo : this.DEFAULT_RETURN_TO
      if (!cipCode || !programGuideCode) {
        return this.$router.push({ name: returnTo })
      }
      this.programGuide = await this.loadProgramGuide({
        cipCode: cipCode,
        programGuideCode: programGuideCode,
        type: this.programGuideType,
        loadDataFromServer: true,
        programInstitutionId: programInstitutionId
      })
      if (!this.programGuide || !this.programGuide.cipCode) {
        return this.$router.push({ name: returnTo })
      }
      let userObj = JSON.parse(localStore.getItem('userobj'))
      if(userObj.institutionId !== this.programGuide.institutionId){
          let affiliatedInstitution = await this.loadInstitutionOnlyDetail(this.programGuide.institutionId)
          this.programGuide.institutionName = affiliatedInstitution.title
      }

      let programPrice = (this.programGuide.pricingPlans && this.programGuide.pricingPlans.length>0) ?'$'+this.programGuide.pricingPlans[0].price:undefined

      this.loadLogDashboardActivity({action: 'viewProgramIntroduction', page: 'programIntroduction', link: '', programCipCode: cipCode, programName:this.programGuide.title, programDescription:this.programGuide.description, thumbnailURL:this.programGuide.thumbnailURL,programPrice})
      // load credit progress
      this.progress = await this.loadProgramCreditProgress({streamId: this.planningStream.uuid, programId: this.programGuide.uuid, recalculate: false})
      this.isProgressCallFailed = (this.progress.status && (this.progress.status === 500))
      // load related career information, if any exists
      await this.loadProgramGuideCareers({ cipCode: this.programGuide.cipCode, code: this.programGuide.code, showAllOccupations: true })
      this.hideLoader()
      await this.redirectIfDisabled()
    },
    returnToClicked () {
      if (this.returnTo === 'relatedPrograms') {
        let routerParams = JSON.parse(localStore.getItem('returnRouterParams'))
        localStore.removeItem('returnRouterParams')
        return this.$router.push({ name: 'programGuideRelatedProgram', params: routerParams, query: {returnTo: routerParams.returnTo} })
      }
      return this.$router.push({ name: this.returnTo })
    },
    deCamelCase () {
      if (!this.returnTo) {
        this.returnTo = this.DEFAULT_RETURN_TO
      }
      if (this.returnTo === this.EXPLORE_RESULTS) {
        return 'return to all results'
      }
      let result = this.returnTo.replace(/([A-Z])/g, ' $1')
      return 'return to ' + result
    },
    getCoursePlanningPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getCoursePlanningPackage(packages)
    },
    getExploreSearchPackage () {
      let packages = this.packages
      if (!packages || !packages.length || packages.length <= 0) {
        return {}
      }
      return PackageUtil.getExploreSearchPackage(packages)
    },
    navigateToCareerProspectsView () {
      return this.$router.push({ name: 'programGuideCareerProspects', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToDegreeRequirementsView () {
      return this.$router.push({ name: 'programGuideDegreeRequirements', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToStreamsView () {
      return this.$router.push({ name: 'programGuideStreams', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToCareersView () {
      return this.$router.push({ name: 'programGuideCareers', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToAlumniInsightsView () {
      return this.$router.push({ name: 'programGuideAlumniInsights', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToStaffView () {
      return this.$router.push({ name: 'programGuideStaff', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToRelatedProgramView () {
      return this.$router.push({ name: 'programGuideRelatedProgram', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    navigateToJobsView () {
      return this.$router.push({ name: 'programGuideJobs', params: this.programGuideRouterParams, query: this.programGuideQueryParam })
    },
    async redirectIfDisabled () {
      let exploreProgramDetailFlagMap = this.exploreProgramDetailFlagMap
      if (!exploreProgramDetailFlagMap || !exploreProgramDetailFlagMap.introductionTab) {
        return
      }
      if (exploreProgramDetailFlagMap.introductionTab.enabled) {
        return
      }
      if (exploreProgramDetailFlagMap.careerProspectsTab.enabled) {
        return this.navigateToCareerProspectsView()
      }
      if (exploreProgramDetailFlagMap.degreeRequirementsTab.enabled) {
        return this.navigateToDegreeRequirementsView()
      }
      if (exploreProgramDetailFlagMap.streamsTab.enabled) {
        return this.navigateToStreamsView()
      }
      if (exploreProgramDetailFlagMap.careersTab.enabled) {
        return this.navigateToCareersView()
      }
      if (exploreProgramDetailFlagMap.alumniInsightsTab.enabled) {
        return this.navigateToAlumniInsightsView()
      }
    },
    calculateCreditProgressClicked (programGuide) {
      this.selectedProgramGuide = programGuide
      this.creditProgressTargetId = 'creditProgressPopup_' + programGuide.uuid
      this.showCreditProgressPopup = true
    }
  },
  computed: {
    ...mapState({
      'programGuideObject': state => state.programguide.programGuideObject,
      'careersObject': state => state.programguide.careers,
      'careerResult': state => state.programguide.careerResult,
      'alumniStreamRecommendations': state => state.stream.alumniStreamRecommendations,
      'advisorStreamRecommendations': state => state.stream.advisorStreamRecommendations,
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'planningStream': state => state.dashboard.planningStream
    }),
    exploreProgramsFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAMS
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    formattedProgramGuide () {
      let formattedProgramGuide = this.programGuideObject
      return formattedProgramGuide
    },
    formattedCareers () {
      let careers = this.careersObject
      let formattedCareers = []
      if (!careers || !careers.targetOccupations || !careers.targetOccupations.length || !careers.targetOccupations.length === 0) {
        return formattedCareers
      }
      careers.targetOccupations.forEach((career) => {
        formattedCareers.push(JSON.parse(career))
      })
      return formattedCareers
    },
    formattedCareer () {
      let formattedCareer = (this.careerResult && this.careerResult.uuid) ? this.careerResult : this.careersObject
      if (!formattedCareer || !formattedCareer.uuid) {
        return {}
      }
      return formattedCareer
    },
    recommendationFeatureMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFeatureFromPackage(coursePlanningPackage, featureId)
    },
    recommendationFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.STREAM_RECOMMENDATIONS_FEATURE_ID
      let coursePlanningPackage = this.getCoursePlanningPackage()
      return PackageUtil.getFlagsFromPackageFeature(coursePlanningPackage, featureId)
    },
    showRecommendationsTab () {
      return this.isRecommendationFeatureEnabled && (this.isAlumniStreamRecommendationsEnabled || this.isAdvisorStreamRecommendationsEnabled)
    },
    isRecommendationFeatureEnabled () {
      return this.recommendationFeatureMap.enabled
    },
    isAlumniStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAlumniStreamRecommendations.enabled
    },
    isAdvisorStreamRecommendationsEnabled () {
      return this.recommendationFlagMap.showAdvisorStreamRecommendations.enabled
    },
    programGuideType () {
      let programGuideType = this.type
      if (!programGuideType || !programGuideType.length || programGuideType.length <= 0) {
        programGuideType = this.DEFAULT_TYPE
      }
      return programGuideType
    },
    exploreProgramDetailFlagMap () {
      let featureId = PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL
      let exploreSearchPackage = this.getExploreSearchPackage()
      return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
    },
    programGuideRouterParams () {
      let programGuide = this.programGuide
      let routerParams = {
        cipCode: programGuide.cipCode,
        programGuideCode: programGuide.code,
        type: programGuide.type,
        returnTo: this.returnTo || 'exploreProgramGuideResults',
        showBackToResultButton: true
      }
      return routerParams
    },
    programGuideQueryParam () {
      let queryParam = {
        returnTo: this.$route.query.returnTo || this.DEFAULT_RETURN_TO
      }
      return queryParam
    },
    showAddCompletedCoursesOnResult () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultAddCompletedCourses) {
        return false
      }
      return exploreProgramsFlagMap.searchResultAddCompletedCourses.enabled
    },
    showInstitutionName () {
      let userObj = JSON.parse(localStore.getItem('userobj'))
      return (userObj.institutionId !== this.programGuide.institutionId)
    },
    async getInstitutionName () {
      return this.programGuide.institutionName
    },
    showTransferredCoursesCreditProgress () {
      let transferCoursesFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.TRANSFER_PREVIOUS_COURSES_FEATURE_ID]
      if (transferCoursesFeature && transferCoursesFeature.enabled) {
        let flags = transferCoursesFeature.flags
        for (let i = 0; i < flags.length; i++) {
          let flag = flags[i]
          if (flag.title === 'showTransferredCoursesCreditProgress') {
            return flag.enabled
          }
        }
      }
      return false
    },
    showCalculateRequiredCredit () {
      let exploreProgramsFlagMap = this.exploreProgramsFlagMap
      if (!exploreProgramsFlagMap || !exploreProgramsFlagMap.searchResultCalculateRequiredCredit) {
        return false
      }
      return exploreProgramsFlagMap.searchResultCalculateRequiredCredit.enabled
    },
    isShowCourseProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCourseProgress' || flags[i].title === 'showCourseProgressOnOverall') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isShowCreditProgressEnabled () {
      let progressViewFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROGRESS_VIEW_FEATURE_ID]
      if (progressViewFeature && progressViewFeature.enabled) {
        let flags = progressViewFeature.flags
        for (var i = 0; i < flags.length; i++) {
          if (flags[i].title === 'showCreditProgress') {
            return flags[i].enabled
          }
        }
      }
      return false
    },
    isStudentLogin () {
      return (localStorage.getItem('userrole') === 'Student')
    }
  },
  watch: {
  }
}
</script>

<style scoped>
  .lnk_req_credit {
    font-size: 16px;
    margin-right: 8px;
    color: #157099;
    float: right;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/programguide/components/ProgramGuideIntroduction.vue